import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAccess, setFields } from "../redux-stuff/counterSlice";
import { _clearTokens } from "../api/authAPI";
import logo from "../img/0task-logo.svg";
import Cookies from "js-cookie";

// simply add the name and the path
const navigation = [
  { name: "Notes", to: "notes" },
  // { name: "Tools", to: "tools" }, can start by adding a calcualtor that determines how much interest accrues per day
  { name: "Tasks", to: "tasks" },
  { name: "Files", to: "files" },
  { name: "Account", to: "user-info" },
];

export default function Header() {
  const token = Cookies.get("user-0task");
  // console.log("Cookie: ", token);
  const refreshToken = useSelector((state) => state.counter.refreshToken);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  async function logout() {
    Cookies.remove("user-0task");
    console.log("Log out has been clicked");

    const data = await _clearTokens(token, refreshToken);

    console.log(data.status);
  }

  return (
    <header className="bg-gray-900">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <button href="#" className="-m-1.5 p-1.5">
            <span className="sr-only">Your Company</span>
            <img className="h-8 w-auto" src={logo} alt="" />
          </button>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <button
              key={item.name}
              onClick={() => {
                navigate(`../${item.to}`);
              }}
              className="text-sm font-semibold leading-6 text-white hover:cursor-pointer"
            >
              {item.name}
            </button>
          ))}
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          {token === undefined ? (
            <button
              onClick={() => {
                navigate("./login");
              }}
              className="text-sm font-semibold leading-6 text-white hover:cursor-pointer"
            >
              Log in <span aria-hidden="true">&rarr;</span>
            </button>
          ) : (
            <button
              onClick={() => {
                logout();
                setMobileMenuOpen(false);
                navigate("./login");
              }}
              className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-white hover:bg-gray-800 hover:cursor-pointer"
            >
              Log out
            </button>
          )}
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-gray-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-white/10">
          <div className="flex items-center justify-between">
            <button href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img className="h-8 w-auto" src={logo} alt="" />
            </button>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-400"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/25">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => {
                      setMobileMenuOpen(false);
                      navigate(`../${item.to}`);
                    }}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:bg-gray-800"
                  >
                    {item.name}
                  </button>
                ))}
              </div>
              <div className="py-6">
                {token === undefined ? (
                  <button
                    onClick={() => {
                      setMobileMenuOpen(false);
                      navigate("./login");
                    }}
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-white hover:bg-gray-800 hover:cursor-pointer"
                  >
                    Log in
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      logout();
                      setMobileMenuOpen(false);
                      navigate("./login");
                    }}
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-white hover:bg-gray-800 hover:cursor-pointer"
                  >
                    Log out
                  </button>
                )}
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
}
